module.exports = __webpack_public_path__ + "static/media/Estampa_VirgenCoromoto_small.c98ba795.jpg";